import { useLanguage } from '../context';
import { getTranslation } from '../translations';

export const useTranslation = () => {
  const { language } = useLanguage();
  const t = getTranslation(language);

  return { t, language };
};

export default useTranslation;
